module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('v-form', [_c('v-layout', [_c('v-flex', [_c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.dialogs.icd10),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "icd10", $$v)
      },
      expression: "dialogs.icd10"
    }
  }, [_c('v-system-bar', {
    staticClass: "visible-ios-only main",
    attrs: {
      "color": _vm.themeColor
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dark": "",
      "dense": "",
      "short": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.icd10picker')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.icd10 = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('icd-picker', {
    attrs: {
      "initial-search-string": _vm.codeSearchString
    },
    on: {
      "input": _vm.setIcdCode
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.icd10 = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "mr-1",
    attrs: {
      "append-icon": "search",
      "box": "",
      "label": "icd10 code"
    },
    on: {
      "click:append": _vm.showICDPicker
    },
    model: {
      value: (_vm.treatmentlog.icd10),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "icd10", $$v)
      },
      expression: "treatmentlog.icd10"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.dialogs.process),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "process", $$v)
      },
      expression: "dialogs.process"
    }
  }, [_c('v-system-bar', {
    staticClass: "visible-ios-only main",
    attrs: {
      "color": _vm.themeColor
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dark": "",
      "dense": "",
      "short": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.processpicker')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.process = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('process-code-picker', {
    attrs: {
      "initial-search-string": _vm.processSearchString
    },
    on: {
      "input": _vm.setProcessCode
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.processcodepicker = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.done')))])], 1)], 1)], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "mr-1",
    attrs: {
      "append-icon": "search",
      "box": "",
      "label": "process code"
    },
    on: {
      "click:append": _vm.showProcessPicker
    },
    model: {
      value: (_vm.treatmentlog.process),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "process", $$v)
      },
      expression: "treatmentlog.process"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "prefix": _vm.currency,
      "box": "",
      "label": "price"
    },
    model: {
      value: (_vm.treatmentlog.price),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "price", $$v)
      },
      expression: "treatmentlog.price"
    }
  })], 1)], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v(_vm._s(_vm.$t('subtitles.dates')))]), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.dialogs.startdate),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "startdate", $$v)
      },
      expression: "dialogs.startdate"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "scrollable": ""
    },
    model: {
      value: (_vm.treatmentlog.start_date),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "start_date", $$v)
      },
      expression: "treatmentlog.start_date"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.startdate = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.cancel')))])], 1)], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "persistent-hint": "",
      "readonly": "",
      "label": _vm.$t("fields.labels.started"),
      "hint": _vm.$t("fields.hints.started"),
      "prepend-icon": "event"
    },
    on: {
      "click": function($event) {
        _vm.dialogs.startdate = true
      },
      "click:prepend": function($event) {
        _vm.dialogs.startdate = true
      }
    },
    model: {
      value: (_vm.treatmentlog.start_date),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "start_date", $$v)
      },
      expression: "treatmentlog.start_date"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.dialogs.stopdate),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "stopdate", $$v)
      },
      expression: "dialogs.stopdate"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "min": _vm.treatmentlog.start_date,
      "scrollable": ""
    },
    model: {
      value: (_vm.treatmentlog.stop_date),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "stop_date", $$v)
      },
      expression: "treatmentlog.stop_date"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.stopdate = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.cancel')))])], 1)], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "persistent-hint": "",
      "readonly": "",
      "clearable": "",
      "label": _vm.$t("fields.labels.end_date"),
      "hint": _vm.$t("fields.hints.end_date"),
      "prepend-icon": "event"
    },
    on: {
      "click": function($event) {
        _vm.dialogs.stopdate = true
      },
      "click:prepend": function($event) {
        _vm.dialogs.stopdate = true
      }
    },
    model: {
      value: (_vm.treatmentlog.stop_date),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "stop_date", $$v)
      },
      expression: "treatmentlog.stop_date"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "pa-0",
    attrs: {
      "persistent-hint": "",
      "label": _vm.$t('fields.labels.auto'),
      "hint": _vm.$t('fields.hints.auto')
    },
    model: {
      value: (_vm.treatmentlog.automatically_add_to_appointments),
      callback: function($$v) {
        _vm.$set(_vm.treatmentlog, "automatically_add_to_appointments", $$v)
      },
      expression: "treatmentlog.automatically_add_to_appointments"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("save", _vm.treatmentlog)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('buttons.save')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42427268","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientTreatment.vue
// module id = 1405
// module chunks = 9